import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";
import { browserShape, withBrowser } from "../../context";
import { formatDateTime } from "../../utils";

type Props = {
  ticket?: {
    id?: string;
    status?: string;
    number?: string;
    subject?: string;
    updated_at?: string;
  };
  intl?: intlShape;
  browser?: browserShape;
};

export function TicketItem({ intl, browser, ticket }: Props) {
  const onClick = () => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    browser.navigateTo(`/support/tickets/${ticket.id}`);
  };

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const updatedAt = `${intl.formatMessage({ id: "label.updated_at" })}: ${formatDateTime(ticket.updated_at, intl)}`;
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const status = `${intl.formatMessage({ id: "label.status" })}: ${intl.formatMessage({ id: `support.status.${ticket.status}` })}`;

  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  return (
    <li id="ticket-item" className="list-item clickable" onClick={onClick}>
      <div className="list-item-content">
        <div className="list-item-header">
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {`${ticket.number} - ${ticket.subject}`}
        </div>
        <div id="ticket-item-status" className="list-item-details">
          {status}
        </div>
        <div id="ticket-item-updated-at" className="list-item-details">
          {updatedAt}
        </div>
      </div>
    </li>
  );
}
// @ts-expect-error TS(2345) FIXME: Argument of type 'FC<WithIntlProps<WrappedComponen... Remove this comment to see the full error message
export default withBrowser(injectIntl(TicketItem));
